import { formatCurrency } from '~/lib/CurrencyHelpers';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import PrintableGiftCertificate from '~/components/giftcertificates/PrintableGiftCertificate';
import { formatDate, formatDateTime } from '~/lib/DateTime';

const GiftCertificateDeliveryInfo = ({ giftCertificate }) => {
    return (
        <div>
            {!!giftCertificate.sent_at && (
                <>
                    This was delivered {formatDateTime(giftCertificate.sent_at)}
                </>
            )}
            {!giftCertificate.sent_at && !!giftCertificate.send_at && (
                <>
                    This will be sent to{' '}
                    {giftCertificate.recipient?.email || (
                        <span className="text-red-700">no email provided</span>
                    )}{' '}
                    on {formatDate(giftCertificate.send_at)}
                </>
            )}
        </div>
    );
};

const SingleGiftCertificate = ({ giftCertificate, token }) => {
    return (
        <div className="py-2 flex flex-col items-center">
            <PrintableGiftCertificate
                business={null}
                recipient={giftCertificate.recipient}
                purchaserName={giftCertificate.purchaser_name}
                message={giftCertificate.settings?.message}
                image={giftCertificate.settings?.image}
                value={giftCertificate.value}
                expires={giftCertificate.expires_at}
                code={giftCertificate.code.code}
                className="min-w-[300px] mb-6"
                small={true}
            />
            <div>
                <span className="font-semibold">
                    {formatCurrency(giftCertificate.value)}
                </span>{' '}
                gift certificate to {giftCertificate.recipient?.name}
            </div>
            <GiftCertificateDeliveryInfo giftCertificate={giftCertificate} />
            <div className="flex">
                <Link
                    className="form-button no-underline mt-2"
                    to={`${giftCertificate.view_link}?print=true`}
                >
                    Print
                </Link>
            </div>
        </div>
    );
};

const PublicGiftCertificatesList = ({ giftCertificates, token }) => {
    return (
        <div>
            {giftCertificates.map(gc => (
                <SingleGiftCertificate
                    key={gc.id}
                    giftCertificate={gc}
                    token={token}
                />
            ))}
        </div>
    );
};

export default PublicGiftCertificatesList;
